<template>
  <div>123
    <div class="img_upload img_load_box">
      <img
        class="previewer-demo-img"
        :key="index"
        :src="ioslocId"
        width="100"
        @click="previewImg(index)"
      >
      <icon type="clear" class="del_pic" @click.native="deletePic(index)">A</icon>
    </div>
    <div class="img_upload img_load_btn" @click="imgup" v-if="imgBoolean">
      <div>
        <!-- <img src="@/assets/images/add-btn.png" alt> -->B
      </div>
    </div>
  </div>
</template>
<script>
// import { getInit } from '@/api/login' // 初始化微信前端的接口
import wx from 'weixin-js-sdk'
export default {
  name: 'WxCarSearch',
  data () {
    return {
      ioslocId: '',
      imgBoolean: true
    }
  },
  mounted () {
    this.initWxConfig()
  },

  methods: {
    base64ToFile (base64, fileName) {
      // base64转file文件
      const arr = base64.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bytes = atob(arr[1])
      let n = bytes.length
      const ia = new Uint8Array(n)
      while (n--) {
        ia[n] = bytes.charCodeAt(n)
      }
      return new File([ia], fileName, { type: mime })
    },
    // 初始化微信前端代码
    initWxConfig () {
    //   const $this = this
      const url = location.href.split('#')[0]
      console.log(url)
    //   getInit(url).then(res => {
    //     wx.config({
    //       debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //       appId: res.data.appId, // 必填，公众号的唯一标识
    //       timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    //       nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    //       signature: res.data.signature, // 必填，签名
    //       jsApiList: ['checkJsApi', 'chooseImage', 'previewImage', 'uploadImage', 'getLocalImgData']// 必填，需要使用的JS接口列表，所有JS接口列表
    //     })
    //     wx.error(function (res) {
    //         alert('出错了：' + res.errMsg)// 这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
    //     })
    //   })
    },
     // 开启摄像头，图片上传
    imgup () {
        debugger
      wx.config({
            debug: false, // 调试
            appId: '', // 必填，公众号的唯一标识
            timestamp: '', // 必填，生成签名的时间戳
            nonceStr: '', // 必填，生成签名的随机串
            signature: '', // 必填，签名
            jsApiList: ['chooseImage', 'getLocalImgData'] // 需要使用的方法的名称
          })
          wx.ready(() => {
            wx.chooseImage({
              count: 1, // 默认9
              sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有（我使用的压缩图）
              sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
              success: function (res) {
                const file = res.localIds[0]
                wx.getLocalImgData({ // 使用这个方法将chooseImage返回的临时路径转换为base64编码
                  localId: file.toString(),
                  success: function (res) {
                    const localData = res.localData
                    let imageBase64 = ''
                    if (localData.indexOf('data:image') === 0) {
                      // 苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
                      imageBase64 = localData
                    } else {
                      // 此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
                      // 此时一个正常的base64图片路径就完美生成赋值到img的src中了
                      imageBase64 =
                        'data:image/jpeg;base64,' +
                        localData.replace(/\n/g, '')
                    }
                    const file = this.base64ToFile(imageBase64, 'headImage.jpg') // 在将base64编码转换成file文件即可上传
                    console.log(file)
                    // that.上传图片的方法(file)
                  }
                })
              },
              fail: function (res) {
                console.log('失败')
                console.log(res)
              }
            })
          })
          wx.error(function (res) {
            console.log(res)
          })
    },
    // 图片展示
    readImages () {
      const $this = this
      wx.getLocalImgData({
        // 调用 getLocalImgData
        localId: $this.ioslocId, // 图片的localID
        success: function (res) {
          var localData = res.localData // localData是图片的base64数据，可以用img标签显示
          if (window.__wxjs_is_wkwebview) {
            // ios
            localData = localData.replace('jgp', 'jpeg') // iOS 系统里面得到的数据，类型为 image/jgp,因此需要替换一下
          } else {
            localData = 'data:image/jpeg;base64,' + localData // android
          }
          $this.ioslocId = localData // 把base64格式的图片添加到ioslocId数组里 这样该数组里的元素都是base64格式的
        },
        fail: (err) => {
          console.log('错误' + err)
        }
      })
    },
    // 图片预览
    previewImg (index) {
      this.$refs.previewer.show(index)
    },
    // 删除图片
    deletePic () {
    //   需要的可以自己实现
    }
  }
}
</script>
